import Component from "./Component.js"

export default class Poster extends Component {

  static get contextTypes() {
    return super.contextTypes
  }

  onmediachange(event) {
    this.setState({src: this.player.evaluateBindings(this.player.media.poster)})
  }

  render() {
    return (
      <img className="amp-poster" src={this.state.src} />
    )
  }
}
